import _typeof from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || time === null || time === undefined || time === '') {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if (_typeof(time) === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  var d = new Date(time);
  var now = Date.now();
  var diff = (now - d) / 1000;
  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime2(time, option) {
  var diff = time / 1000;
  if (diff < 30) {
    return '0' + '秒';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时';
  } else if (diff < 3600 * 24 * 2) {
    return '1天';
  }
  if (option) {
    return parseTime(time, option);
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  var search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') + '"}');
}

/**
 * 添加天数
 *
 * @param {*} date
 * @param {*} days
 */
export function addDate(date, days) {
  if (days === undefined || days === '') {
    days = 1;
  }
  var newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  var month = newDate.getMonth() + 1;
  var day = newDate.getDate();
  var mm = "'" + month + "'";
  var dd = "'" + day + "'";

  // 单位数前面加0
  if (mm.length === 3) {
    month = '0' + month;
  }
  if (dd.length === 3) {
    day = '0' + day;
  }
  var time = newDate.getFullYear() + '-' + month + '-' + day;
  return time;
}

/**
 * 比较两个日期 2020-02-20
 * @param start 起始日期
 * @param end   结束日期
 * @returns {boolean} true|false
 */
export var compareDate = function compareDate(start, end) {
  return new Date(end).getTime() > new Date(start).getTime();
};

/**
 * 生成随机len位数字
 */
export var randomNum = function randomNum(len, date) {
  var random = '';
  random = Math.ceil(Math.random() * 100000000000000).toString().substr(0, len || 4);
  if (date) random = random + Date.now();
  return random;
};

/**
 * 动态插入css
 */
export var loadStyle = function loadStyle(url) {
  var link = document.createElement('link');
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = url;
  var head = document.getElementsByTagName('head')[0];
  head.appendChild(link);
};

/**
 * 设置对象值
 */
export var setObjectValue = function setObjectValue(row, form, type) {
  if (type.indexOf('.') !== -1) {
    var keys = type.split('.');
    var val = row[keys[0]][keys[1]];
    if (val instanceof Object) {
      form[keys[1]] = val['name'];
    } else {
      form[keys[1]] = val;
    }
  } else {
    if (row[type] !== null) {
      if (row[type] instanceof Object) {
        form[type + 'Name'] = row[type].name;
        form[type] = row[type].id;
      } else {
        form[type] = row[type];
      }
    }
  }
};

/**
 * 设置对象值
 */
export var setObjectIdValue = function setObjectIdValue(row, form, type) {
  if (type.indexOf('.') !== -1) {
    var keys = type.split('.');
    var val = row[keys[0]][keys[1]];
    if (val instanceof Object) {
      form[keys[1]] = val['name'];
    } else {
      form[keys[1]] = val;
    }
  } else {
    if (row[type] !== null) {
      if (row[type] instanceof Object) {
        form["".concat(type, "Name")] = row[type].name;
        form["".concat(type, "Id")] = row[type].id;
      } else {
        form[type] = row[type];
      }
    }
  }
};

/**
 * 设置对象ID
 * @param {*} row
 * @param {*} form
 * @param {*} field
 */
export var setObjectId = function setObjectId(row, form, field) {
  if (row[field] !== null) {
    form["".concat(field, "Id")] = row[field].id;
  }
};

/**
 * 获取对象名称
 * @param {*} obj
 */
export var getObjectName = function getObjectName(obj) {
  return obj['name'] == null ? '' : obj['name'];
};

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
    ele.className = ele.className.replace(reg, ' ');
  }
}

/**
 * 数字转汉字(不超过10)
 * @param {*} num
 * @returns
 */
export function chineseNum(num) {
  var arr = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
  if (num > 10) {
    num = 0;
  }
  return arr[num];
}

/**
 * 数字转英文(不超过10)
 * @param {*} num
 * @returns
 */
export function englishNum(num) {
  var arr = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];
  if (num > 10) {
    num = 0;
  }
  return arr[num];
}

/**
 * 格式化金额
 */
export function formatDecimal(num) {
  return Number(parseFloat(num)).toFixed(5).slice(0, -1);
}

/**
 * 对象不为空
 * @param {*} obj 
 * @returns 
 */
export function isNotEmpty(obj) {
  return obj !== undefined && obj !== null && obj !== '' && obj !== 'null';
}

/**
 * 格式化数字
 * @param {*} value
 * @param {number} precision 精度，默认2位小数
 * @returns
 */
export function formatNumber(value) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var num = Number(value) || 0;
  return num.toFixed(precision);
}

/**
 * 将 Hex 颜色转换为符合 Element UI 风格的 Tag 样式对象
 * @param {string} hexColor 十六进制颜色值 (如 #13c2c2)
 * @param {boolean} isDark 是否为深色模式
 */
export var getTagStyle = function getTagStyle(hexColor) {
  var isDark = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!hexColor) return {};
  if (isDark) {
    return {
      backgroundColor: hexColor,
      borderColor: hexColor,
      color: '#ffffff'
    };
  }

  // 这里的 '1a' 和 '4d' 是 Hex 透明度通道 (00-ff)
  // 1a 约等于 10% 透明度，用于背景
  // 4d 约等于 30% 透明度，用于边框
  return {
    backgroundColor: hexColor + '1a',
    borderColor: hexColor + '4d',
    color: hexColor,
    borderWidth: '1px',
    borderStyle: 'solid'
  };
};